import React, {Component} from 'react';
import { TextField, List, ListItem, ListItemText } from "@mui/material";
import firebase from "./../firebase";
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";
//import $ from 'jquery';
import './jquery.dataTables.min.css';
import moment from 'moment';

const $ = require('jquery');
$.DataTable = require('datatables.net');

export default class Bodycontenttv extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: [],
            role: '',
            count:0,
            count_logs: 0,
            myip: '',
            mylocation: '',
            channels: [],
            datatable: [],
            addsopcast: 'sop://broker.sopcast.com:3912/6002',
            addtitlesopcast: 'CCV5'
        };
    }

    componentDidMount() {
      //alert(localStorage.getItem('user_id'))
      this.getUser()
      this.logs()
      this.getChannels()
      setTimeout(function(){
      this.$el = $(this.el)
      this.$el.DataTable({
        data: this.state.datatable,
        columns: [
          {"title": "ID","data": "ID"},
          {"title": "Category","data": "Category"},
          {"title": "Image","data": "Image"},
          {"title": "Title","data": "Title"},
          {"title": "Play in Sopcast","data": "PlayS"},
          {"title": "Play in Browser","data": "PlayB"},
        ]
      })
      }.bind(this), 4500); 
    }

    //componentWillUnmount(){
    //  this.$el.DataTable.destroy(true);
    //}

    logs = () => {
      //alert('Did Logs');
      //firebase.database().ref("/logs").on('value', snapshot => {
      const db = getDatabase();
      get(ref(db,"logs")).then((snapshot)=>{
        var select_logs = []
        snapshot.forEach(child => {
          var data = child.val()
          select_logs.push({
              id: data.id,
              status: data.status,
              message: data.message,
              agent: data.agent,
              ip: data.ip,
              location: data.location,
              user_id: data.user_id,
              time: data.time,
            })
        this.setState({ count_logs: select_logs.length })
        
        })
      })
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((data) => {
          //alert(JSON.stringify(data.ip))
            setTimeout(function(){ 
              this.setState({ myip: data.ip, mylocation: data.country_name+'#'+data.region })
            }.bind(this), 200);
  
      setTimeout(function(){ 
      //alert(JSON.stringify(this.state.count_logs));
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      /*var refdb = firebase.database().ref('/logs').push();
      refdb = refdb.toString().slice(-20);
      
      let updateData = firebase.database().ref("/logs").child(refdb);
      updateData.child("id").set(this.state.count_logs+1);
      updateData.child("status").set('1');
      updateData.child("message").set('User Access TV Page');
      updateData.child("agent").set(navigator.userAgent);
      updateData.child("ip").set(this.state.myip);
      updateData.child("location").set(this.state.mylocation);
      updateData.child("user_id").set(localStorage.getItem('user_id'));
      updateData.child("time").set(curtime);*/
      var refdb = push(ref(db,'/logs'));
      //refdb_ref = refdb.toString().slice(-20);
      
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((dataipres) => {
          //let updateData = ref(db,"logs/"+refdb);
          set(refdb,{
            id:this.state.count_logs+1,
            status:'1',
            message:'User Access TV Page',
            agent:String(navigator.userAgent),
            ip: String(dataipres.ip),
            location:String(dataipres.country_name+'#'+dataipres.region),
            user_id:String(localStorage.getItem('user_id')),
            time:String(curtime)
          });
        });
      }.bind(this), 400);
    })

    }

    getUser = () => {
      /*firebase.database().ref("/users").orderByChild('email')
      .equalTo(localStorage.getItem('user_id')).on('value', snapshot => {*/
      const db = getDatabase();
      get(query(ref(db, 'users'), orderByChild('email'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
        var userg = []
        snapshot.forEach(child => {
          var data = child.val()
        userg.push({
          id: data.key, 
          email: data.email,
          name: data.name,
          nickname: data.nickname,
          phone: data.phone,
          role: data.role,
          time: data.time
        })
        this.setState({ user: userg })
      })
        
      })
      setTimeout(function(){ 
        this.setState({ role: JSON.stringify(this.state.user[0].role) })
        //alert(JSON.stringify(this.state.role))
      //alert(JSON.stringify(this.state.user[0].role))   
      }.bind(this), 1000);   
    }
    getChannels = () => {
      setTimeout(function(){ 
      if(this.state.user[0].role==='demo'){
        /*firebase.database().ref("/channels").orderByChild('id')
      .startAt('36').endAt('39').on('value', snapshot => {*/
      var i = 0;
      const db = getDatabase();
      get(ref(db, 'channels')).then((snapshot)=>{
        let newChannels = []
        let newDatatable = []
          snapshot.forEach(child => {
            var channel = child.val()
            if(i<3){
              newChannels.push({id: channel.id,category: channel.category,channel_image: channel.channel_image,channel_title: channel.channel_title,channel_url: channel.channel_url })
              newDatatable.push({ID: channel.id,Category: channel.category,Image: "<img height='30' width='70' src=data:image/png;base64,"+channel.channel_image+">",Title: channel.channel_title,Url: channel.channel_url,PlayS: "<a class='btn btn-warning' href="+channel.channel_url+">Play in Sopcast</a>",PlayB: "<button type='button' class='btn btn-warning' onClick='function hi(){document.getElementsByName(`SopAddress`)[0].value=`"+channel.channel_url+"`;document.getElementsByName(`ChannelName`)[0].value=`"+channel.channel_title+"`;};hi()' data-toggle='modal' data-target='#myModal' >Play in Browser</button>" })
            }
            i++;
          })
          this.setState({ channels: newChannels })
          this.setState({ datatable: newDatatable })
          //setTimeout(function(){
          //alert(JSON.stringify(this.state.datatable))
          //}.bind(this), 2000);
          $('#divch').scrollTop($('#divch')[0].scrollHeight);        
      })
      }
        if(this.state.user[0].role==='admin' || this.state.user[0].role==='user' || this.state.user[0].role==='adminc'){
        //alert(this.state.messages)
        /*var messagesDB = firebase
          .database()
          .ref("/channels")
        messagesDB.on("value", snapshot => {*/
        const db = getDatabase();
      get(ref(db, 'channels')).then((snapshot)=>{
          let newChannels = []
          let newDatatable = []
          snapshot.forEach(child => {
            var channel = child.val()
            newChannels.push({ id: channel.id, category: channel.category,channel_image: channel.channel_image,channel_title: channel.channel_title,channel_url: channel.channel_url })
            newDatatable.push({ID: channel.id,Category: channel.category,Image: "<img height='30' width='70' src=data:image/png;base64,"+channel.channel_image+">",Title: channel.channel_title,Url: channel.channel_url,PlayS: "<a class='btn btn-warning' href="+channel.channel_url+">Play in Sopcast</a>",PlayB: "<button type='button' class='btn btn-warning' onClick='function hi(){document.getElementsByName(`SopAddress`)[0].value=`"+channel.channel_url+"`;document.getElementsByName(`ChannelName`)[0].value=`"+channel.channel_title+"`;};hi()' data-toggle='modal' data-target='#myModal' >Play in Browser</button>" })
          })
          newChannels.splice(-1,1)
          newDatatable.splice(-1,1)
          this.setState({ channels: newChannels })
          this.setState({ datatable: newDatatable })
          //setTimeout(function(){
          //alert(JSON.stringify(this.state.datatable))
          //}.bind(this), 2000);
          //alert(JSON.stringify(this.state.channels))
          $('#divch').scrollTop($('#divch')[0].scrollHeight);
          //this.bottomSpan.scrollIntoView({ behavior: "smooth" })
        })
        }

      }.bind(this), 1000); 
      }

      setsopcast = (address,title) => {
        this.setState({ addsopcast: address})
        this.setState({ addtitlesopcast: title })
      }

      renderChannels = () => {
        //if(this.state.count < this.state.channels.length){
        return this.state.channels.map(channel => (
            <tr><td align="right">{channel.id}</td><td align="right"><img height="30" width="70" src={`data:image/png;base64,${channel.channel_image}`}/></td><td align="center"><a className="btn btn-warning" href={channel.channel_url}>{channel.channel_title}</a></td><td><button type="button" className="btn btn-warning" onClick={() => this.setsopcast(channel.channel_url,channel.channel_title)} data-toggle="modal" data-target="#myModal" >Play in Browser</button></td></tr>
        ));
        //this.setState({ count: this.state.count+1 });
        //}
      }

    render(){
        const divStyled={
            overflowY: 'scroll',
            border:'1px solid red',
            float: 'left',
            height:'162px',
            position:'relative',
            marginBottom: '30px'
          };
          const divStyle={
            overflowY: 'scroll',
            border:'1px solid red',
            float: 'left',
            height:'500px',
            position:'relative',
            marginBottom: '30px'
          };
          const divStyless={  
            height:'150px',
          };
        return (
            <main role="main" className="col-md-9 ml-sm-auto col-lg-10 pt-3 px-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
              <h1 className="h2">Dashboard TV Page</h1>
            </div>
            <p>Dashboard TV Page</p>

            <div id="divch" style={this.state.role==='"demo"'?divStyled:divStyle}><table>{this.renderChannels()}</table></div>
            <table className="display" width="100%" ref={el => this.el = el }></table>

            <div className="modal" id="myModal">
              <div className="modal-dialog">
                <div className="modal-content">

                  <div className="modal-header">
                    <h4 className="modal-title">Modal Heading</h4>
                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                  </div>

                  <div className="modal-body">
                  <object 
                      id="SopPlayer" name = "SopPlayer" 
                      classID="clsid:8FEFF364-6A5F-4966-A917-A3AC28411659" 
                      codebase="http://download.sopcast.com/download/SOPCORE.CAB#version=1,1,2,0" 
                      height="350" width="450">
                      <param name="AutoStart" value="1" />  
                      <param name="SopAddress" value={this.state.addsopcast} />
                      <param name="ChannelName" value={this.state.addtitlesopcast} />
                  </object>
                  </div>

                  <div className="modal-footer">
                    <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                  </div>

                </div>
              </div>
            </div>

            <div style={divStyless}></div>
          </main>  
        )
    }
}